import React from 'react';
import { Card } from '@/components/ui/card';
import { Calendar as CalendarIcon } from 'lucide-react';
import { getSubjectColor } from './subjectColor';
import { WeeklyGridShell } from './WeeklyGridShell';

export const TeacherGridView = ({
  days,
  periods,
  selectedTeacher,
  selectedTeacherName,
  teacherWeeklyStats,
  teacherGridLookup,
}) => (
  <Card className="p-4 sm:p-6" data-testid="teacher-grid-view">
    {!selectedTeacher?.trim() ? (
      <div className="text-center py-12">
        <CalendarIcon className="mx-auto h-12 w-12 text-slate-300 mb-4" />
        <p className="text-slate-600 font-medium mb-1">Select a teacher to view their weekly timetable</p>
        <p className="text-sm text-slate-400">Use the "Filter by teacher" dropdown above</p>
      </div>
    ) : (
      <>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-5 gap-3" data-testid="teacher-grid-header">
          <div>
            <h2 className="text-xl font-bold text-slate-900">{selectedTeacherName}</h2>
            <p className="text-sm text-slate-500">Weekly Timetable</p>
          </div>
          <div className="flex gap-3 text-sm">
            <div className="px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg">
              <span className="font-semibold text-blue-800">{teacherWeeklyStats.lessons}</span>
              <span className="text-blue-600 ml-1">lessons/week</span>
            </div>
            <div className="px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-lg">
              <span className="font-semibold text-emerald-800">{teacherWeeklyStats.free}</span>
              <span className="text-emerald-600 ml-1">free periods</span>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-4" data-testid="teacher-grid-legend">
          {teacherWeeklyStats.subjects.map(s => (
            <span key={s} className={`px-2.5 py-1 rounded-full text-xs font-medium border ${getSubjectColor(s)}`}>{s}</span>
          ))}
        </div>

        <WeeklyGridShell
          days={days}
          periods={periods}
          testId="teacher-grid-table"
          rowTestIdPrefix="teacher-grid-row"
          renderCell={({ day, period, pIdx }) => {
            const entry = teacherGridLookup[`${day}-${period}`];
            return (
              <td key={day} className="p-1.5 border-b border-slate-100 border-l border-slate-50" style={{ minWidth: '160px' }} data-testid={`teacher-grid-cell-${day.toLowerCase()}-p${pIdx + 1}`}>
                {entry ? (
                  <div className={`px-3 py-2 rounded-lg border ${getSubjectColor(entry.subject)} transition-shadow hover:shadow-md`}>
                    <p className="font-semibold text-xs">{entry.class_name}</p>
                    <p className="text-[11px] mt-0.5 opacity-80">{entry.subject}</p>
                  </div>
                ) : (
                  <div className="px-3 py-2 rounded-lg bg-slate-50/50 text-center">
                    <span className="text-xs text-slate-300">Free</span>
                  </div>
                )}
              </td>
            );
          }}
        />
      </>
    )}
  </Card>
);
